import { useTranslation } from 'react-i18next';
import type { TenantType } from '@bliks-io/contracts';
import { Badge } from '@bliks-io/ui';

const TYPE_COLOR_SCHEMES: Record<TenantType, 'indigo' | 'amber' | 'neutral'> = {
  partner: 'indigo',
  demo: 'amber',
  customer: 'neutral'
};

/** Single label source for every tenant-type render (badge, type select). */
export const TENANT_TYPE_LABEL_KEYS: Record<TenantType, string> = {
  partner: 'tenantAdmin.tenantTypePartner',
  demo: 'tenantAdmin.tenantTypeDemo',
  customer: 'tenantAdmin.tenantTypeCustomer'
};

export function TenantTypeBadge({ tenantType }: { tenantType: TenantType }) {
  const { t } = useTranslation();
  return (
    <Badge colorScheme={TYPE_COLOR_SCHEMES[tenantType]}>
      {t(TENANT_TYPE_LABEL_KEYS[tenantType])}
    </Badge>
  );
}
